import { Injectable } from '@angular/core';
import { Firestore, addDoc, collection, collectionData, doc, docData, deleteDoc, updateDoc, DocumentReference, setDoc, query, where } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { SharedService } from '../../../../shared/shared.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  constructor(private firestore: Firestore, private sharedService: SharedService) { }

  addEditOrganization(data: any, id:string) {
    console.log('data', data)
    let collectionRef = 'organisations';
    if(!id) {
      id = doc(collection(this.firestore, collectionRef)).id;
    }
    collectionRef = `organisations/${id}`;
    const studentRef = doc(this.firestore, collectionRef);
    return setDoc(studentRef, data);
  }

  saveOrganisationdata(data: any, id:string) {
    console.log('data', data)
    let collectionRef = 'organisations';
    if(!id) {
      id = doc(collection(this.firestore, collectionRef)).id;
    }
    collectionRef = `organisations/${id}`;
    const studentRef = doc(this.firestore, collectionRef);
    return setDoc(studentRef, data);
  }


  getOrganization(){
    const studentRef = collection(this.firestore, `organisations`);
    return collectionData(studentRef, {idField: 'id'}) as Observable<any>;
  }

  deleteOrganization(id:string) {
    const studentDel = doc(this.firestore, `organisations/${id}`);
    return deleteDoc(studentDel);
  }

  getCountry(){
    const groupRef = collection(this.firestore, `countries`);
    return collectionData(groupRef, {idField: 'id'}) as Observable<any>;
  }

  getStates(countryId:string){
    const stateData = collection(this.firestore, `states`);
    const q = query(stateData, where('countryId', '==', countryId));
    return collectionData(q, {idField: 'id'}) as Observable<any>;
  }

  getRegion(stateId:string){
    const stateData = collection(this.firestore, `regions`);
    const q = query(stateData,where('stateId', '==', stateId));
    return collectionData(q, {idField: 'id'}) as Observable<any>;
  }

	async getOrganizationData(organizationId: string) {
		try {
			const orgData = docData(doc(this.firestore, `organisations/${organizationId}`));
			return await this.sharedService.getObservableRes(orgData);
		} catch (err) {
			console.log('Unable to get organization data');
		}
	}

	async addManagers(orgId: string, hierarchy: any)  {
		try {
			// Deep clone before stripping the view-only keys. A shallow [...hierarchy] copy
			// shares the value objects, so the deletes below used to strip `orgIndex` etc.
			// from the live in-memory hierarchy and break the screen until a reload.
			const hierarchyClone = JSON.parse(JSON.stringify(hierarchy));
			for (let level of hierarchyClone) {
				for (let val of level.values) {
					delete val['orgIndex'];
					delete val['showManagersList'];
					delete val['managerNames'];
					delete val['hasLoadedManagers'];

					// Historic data contains null/duplicate manager ids.
					if (Array.isArray(val['managers'])) {
						val['managers'] = Array.from(new Set(
							val['managers'].filter((id: any) => typeof id === 'string' && id.length >= 1)
						));
					}
				}
			}

			await updateDoc(doc(this.firestore, `organisations/${orgId}`), {
				hierarchy: hierarchyClone
			});

			return { status: 'success' };
		} catch (err) {
			console.log('Unable to add organization mgrs', err);
			return { status: 'failed' };
		}
	}
}
